/**
 * 祝日
 */
export default class Holiday {
  name: string;
  date: Date;

  public constructor(params: Holiday) {
    this.name = params.name;
    this.date = params.date;
  }
}
